/*
 * @Author: ypf2345678 1278729153@qq.com
 * @Date: 2023-07-21 14:45:02
 * @LastEditors: ypf2345678 1278729153@qq.com
 * @LastEditTime: 2023-07-26 15:43:08
 * @FilePath: /npm-component/src/philTable/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import group from './group'
const components = [group]
const install = Vue =>{
  if(install.installed) return
  install.installed=true
  components.map(component=>Vue.use(component))
}
if(typeof window !=='undefined' && window.vue){
  install(window.vue)
}

export default{
  install,
  ...components
}